export type DispenseTillLike = {
  status?: string;
  paymentDate?: string | null;
  refundedAt?: string | null;
};


export function getDispenseTillDisplayInstant(
  d: DispenseTillLike | null | undefined,
): string | null {
  if (!d) return null;
  if (d.status === "refunded" && d.refundedAt) return String(d.refundedAt);
  if (d.paymentDate) return String(d.paymentDate);
  return null;
}
